import {EVENT_ACTIONS, trackEvent} from '@src/analytics.js';
import {useCallback} from 'react';
import useAppSection from './useAppSection.js';

// TODO move this to @src/analytics once it's converted to TypeScript
type EventAction = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS];

const useTrackSectionEvent = () => {
  const {appSection} = useAppSection();

  return useCallback(
    (action: EventAction, target: string, props = {}) => {
      if (!Object.values(EVENT_ACTIONS).includes(action)) {
        throw new Error(`Invalid tracking event action: ${action}`);
      }

      trackEvent(
        [appSection, `${action} ${target}`].filter(p => !!p).join(' - '),
        {
          appSection: appSection || undefined,
          action,
          target,
          ...props,
        },
      );
    },
    [appSection],
  );
};

export default useTrackSectionEvent;
